import './index.scss'
$(document).ready(function () {
    $('.section1 .banner .swiper-slide').addClass('swiper-slide-active')
  });
$(function(){
var s_title=$(".s_t_r .r_i_set");
var s_select=$(".se_i li");

s_title.click(function(e){
    $(this).parent('.r_i').addClass("span_aa");
    $(this).siblings("ul").slideDown();
    e.stopPropagation();
    });		
    
s_select.click(function(){
    var s_text=$(this).html();
    var s_title_2=$(this).parent('ul').siblings(".r_i_set").children('span');
    s_title_2.html(s_text)
    $(this).parent(".r_i").removeClass("span_aa")
    $(this).parent('ul').slideUp();
    });
    
$(document).click(function(){
    $('.r_i').removeClass("span_aa");
    $(".r_i ul").hide();		
    });    
    // proHeight()
    // proHeightSon()
});
$(window).resize(function() {
    // proHeight()
    // proHeightSon()
  });
// 产品每一项的高度统一
// function proHeight(){
//     let numlist = []
//     let num = $('.section3 .item')//.eq(0).height()
//     $.each(num,function(index,item){
//     numlist.push(item.offsetHeight)
//     })
//     let allnum =  Math.max.apply(null, numlist);
//     $('.section3 .item').css({'height': allnum+'px'})
// }

// function proHeightSon(){
//     let sonumlist = []
//     let numson = $('.section3 .item .it_bottom')//.eq(0).height()
//     $.each(numson,function(index,item){
//     sonumlist.push(item.offsetHeight)
//     })
//     let allnumson =  Math.max.apply(null, sonumlist);
//     $('.section3 .item .it_bottom').css({'height': allnumson+'px'})
//   }